<template>
  <div class="p-4 bg-gray-100 border border-gray-200 rounded">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'MInset',
};
</script>

<style>

</style>
